import { render, staticRenderFns } from "./RequestsRegistration.vue?vue&type=template&id=15cd7230&"
import script from "./RequestsRegistration.vue?vue&type=script&lang=js&"
export * from "./RequestsRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports